var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.notificationCount > 0
    ? _c("div", { staticClass: "notification-container" }, [
        _c("span", { staticClass: "notification-circle" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.displayedNotificationCount) + "\n    "
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }